import axios from 'axios';
import http from '../services/httpClient';
import getLanguage from '../utils/getLanguage';
import createTokenLogin from '../utils/tokenLogin';

function redirectToDashboard(router, category) {
  const { href } = router.resolve({
    name: category === 'patient' ? 'DashboardPaciente' : 'DashboardPsicologo',
    query: { language: router.currentRoute.query.language },
  });
  window.location.replace(href);
}

function createFrontendTokenLogin(router) {
  return createTokenLogin({
    async getSession(token) {
      // O cliente compartilhado sobrescreve Authorization com o token da sessão atual.
      const { data } = await axios.get('/users/session/', {
        baseURL: http.defaults.baseURL,
        headers: {
          Authorization: `Token ${token}`,
          language: getLanguage(window.location.href),
        },
      });
      return data;
    },
    storage: window.localStorage,
    redirect: (category) => redirectToDashboard(router, category),
  });
}

export async function loginFromAdmin(router, token) {
  const failureMessage =
    'Não foi possível abrir esta conta. Volte ao Admin e use Abrir frontend novamente.';
  if (typeof token !== 'string' || !/^[a-f0-9]{40}$/i.test(token)) {
    throw new Error(failureMessage);
  }

  try {
    await createFrontendTokenLogin(router)(token);
  } catch (error) {
    throw new Error(failureMessage);
  }
}

export default function installTokenLogin(router) {
  const loginWithToken = createFrontendTokenLogin(router);
  window.ondivan = Object.assign(window.ondivan || {}, { loginWithToken });
}
